import {createReducer} from '@reduxjs/toolkit';
import {TriggerAttachment} from 'src/openapi/models/TriggerAttachment';

import {
    activateTriggerAttachment,
    addTriggerAttachment,
    clearTriggerAttachments,
    deactivateTriggerAttachment,
    removeTriggerAttachment,
    setTriggerAttachments,
} from './actions';

type State = {
    data: TriggerAttachment[],
};

const defaultState: State = {
    data: [],
};

export const triggerAttachments = createReducer<State>(defaultState, builder => builder
    .addCase(addTriggerAttachment, (state, action) => {
        state.data = [...state.data, action.payload];
    })
    .addCase(setTriggerAttachments, (state, action) => {
        state.data = action.payload;
    })
    .addCase(clearTriggerAttachments, state => {
        state.data = [];
    })
    .addCase(removeTriggerAttachment, (state, action) => {
        state.data = state.data.filter(a => a.name !== action.payload);
    })
    .addCase(deactivateTriggerAttachment, (state, action) => {
        state.data = state.data.map(attachment => attachment.id === action.payload ?
                {...attachment, active: false} : attachment);
    }).addCase(activateTriggerAttachment, (state, action) => {
        state.data = state.data.map(attachment => attachment.id === action.payload ?
                {...attachment, active: true} : attachment);
    }),
);
